import { apiClient } from "./client";
import type {
  SoapIngestRequest,
  SoapIngestResponse,
  InvoiceIngestRequest,
  InvoiceIngestResponse,
} from "@/types";

export async function ingestSoap(req: SoapIngestRequest): Promise<SoapIngestResponse> {
  const { data } = await apiClient.post<SoapIngestResponse>("/api/v1/ingest/soap", req);
  return data;
}

export async function ingestInvoice(req: InvoiceIngestRequest): Promise<InvoiceIngestResponse> {
  const { data } = await apiClient.post<InvoiceIngestResponse>("/api/v1/ingest/invoice", req);
  return data;
}
